import styled from 'styled-components';

export const Container = styled.div`
  .inputsearch input {
    text-transform: uppercase;
    &::placeholder{
      color: ${(props) => props.theme.colors.text.placeholder};
      text-transform: uppercase;
    }
  }
`;

export const HeadSection = styled.div`
  display: flex;
  flex-direction: 'column';
`;

export const Label = styled.div`
  color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 10px;
`;

export const FilterSectionItem = styled.div`
  flex: 4;
`;

export const CutSectionItem = styled.div`
  flex: 2;
  margin-left: 14px;
`;

export const BodySection = styled.div`
  overflow-y: scroll;
  height: 165px;
  `;

export const CollapsibleListWrapper = styled.div`
  margin-bottom: 3px;
`;

export const ErrorSection = styled.div`
`;
